export enum DmsTypeEnum  {
  Ideal=  0,
  Infinity= 1,
  Aspen= 9,
  DIS= 12,
};

export namespace DmsTypeEnum {
  export function getName(value: number): string {
    return Object.keys(DmsTypeEnum)
      .find((key) => DmsTypeEnum[key as keyof typeof DmsTypeEnum] === value) || "";
  }
}

export enum ClientAppEnum {
  Notify2 = 'Notify2',
  TargetCRM = 'TargetCRM',
}
